import { http, type Page } from '@shared/api';
import type { ProductListQuery, ProductRequest, ProductView } from '../model/types';

function buildSearchParams(query: ProductListQuery): URLSearchParams {
  const params = new URLSearchParams();
  if (query.status?.length) params.set('status', query.status.join(','));
  if (query.category) params.set('category', query.category);
  if (query.stock !== undefined) params.set('stock', String(query.stock));
  if (query.q) params.set('q', query.q);
  params.set('page', String(query.page ?? 0));
  params.set('size', String(query.size ?? 20));
  return params;
}

export const productApi = {
  list: (query: ProductListQuery) =>
    http.get('products', { searchParams: buildSearchParams(query) }).json<Page<ProductView>>(),

  get: (id: string) => http.get(`products/${id}`).json<ProductView>(),

  create: (body: ProductRequest) => http.post('products', { json: body }).json<ProductView>(),

  update: (id: string, body: ProductRequest) =>
    http.put(`products/${id}`, { json: body }).json<ProductView>(),

  submit: (id: string) => http.post(`products/${id}/submit`).json<ProductView>(),

  archive: (id: string) => http.delete(`products/${id}`).json<void>(),
};
